module.exports = __webpack_public_path__ + "img/student2.3de4506b.svg";